import { LANDING_PAGE_URL } from '../config/alia';

export default () => {
  const launcher = document.getElementById('aliaLauncher');
  const dialog = document.getElementById('aliaDialog');

  if (!launcher || !dialog) return;

  document.getElementById('aliaBannerLink').href = LANDING_PAGE_URL;
  document.getElementById('aliaCta').href = LANDING_PAGE_URL;

  if (typeof dialog.showModal !== 'function') {
    launcher.addEventListener('click', () => window.open(LANDING_PAGE_URL, '_blank', 'noopener'));
    return;
  }

  const close = () => dialog.close();

  launcher.addEventListener('click', () => dialog.showModal());
  [].forEach.call(dialog.querySelectorAll('[data-alia-close]'), el => el.addEventListener('click', close));

  // Clicks on the backdrop land on the <dialog> itself; clicks on its content don't.
  dialog.addEventListener('click', event => {
    if (event.target === dialog) close();
  });
};
